import { isEmpty } from 'lodash';
import {
  questionnaireLogicService,
  FinalNode,
  RespondentKnowledge,
} from './logic';
import { storeActions } from './store-actions';

Pollfish.store = (function store() {
  return {
    monitoring: {
      rejectedSurveys: {},
      reportedRejectionErrors: false,
      offersImpression: [],
    },
    shuffledAnswers: {},
    userRejectedSurveys: [],

    initRespondentKnowledge(
      respondentKnowledge,
      extraTaxonomyProperties,
      extraQuotasProperties,
      extraQuotaAssignedProperties,
      extraQuotaStrategiesProperties,
      extraQuotaLimitTypesProperties,
      extraNoneOfTheAboveAnswers,
      extraRemainingCompletes,
    ) {
      const knowledge =
        respondentKnowledge || RespondentKnowledge.getDefaultData();
      knowledge.taxonomyDevice = {
        ...(knowledge.taxonomyDevice || {}),
        ...extraTaxonomyProperties,
      };
      knowledge.quotas = {
        ...(knowledge.quotas || {}),
        ...extraQuotasProperties,
      };

      knowledge.quotaAssigned = {
        ...(knowledge.quotaAssigned || {}),
        ...extraQuotaAssignedProperties,
      };

      knowledge.quotaStrategies = {
        ...(knowledge.quotaStrategies || {}),
        ...extraQuotaStrategiesProperties,
      };

      knowledge.quotaLimitTypes = {
        ...(knowledge.quotaLimitTypes || {}),
        ...extraQuotaLimitTypesProperties,
      };

      knowledge.noneOfTheAboveAnswers = {
        ...(knowledge.noneOfTheAboveAnswers || {}),
        ...extraNoneOfTheAboveAnswers,
      };

      if (extraRemainingCompletes !== undefined) {
        knowledge.remainingCompletes = extraRemainingCompletes;
      }

      this.respondentKnowledge = questionnaireLogicService.setKnowledge(
        knowledge,
      );

      this.respondentKnowledge.store.extend(storeActions);
    },

    getRespondentKnowledge() {
      if (!this.respondentKnowledge) {
        this.respondentKnowledge = this.initRespondentKnowledge();
      }

      return this.respondentKnowledge.getData();
    },

    updateRespondentKnowledgeByKey(key, updatedRespondentKnowledge) {
      this.respondentKnowledge.update({
        [key]: updatedRespondentKnowledge[key],
      });
    },

    updateKnowledgeByAdlOutcomeEvaluation(
      outcomeType,
      nodeRefId,
      questionnaireLogic,
    ) {
      if (nodeRefId === FinalNode || isEmpty(questionnaireLogic)) {
        return;
      }

      questionnaireLogicService.evaluateKnowledgeForNode(
        questionnaireLogic,
        nodeRefId,
        [outcomeType],
      );
    },
    addTaxonomyData(taxonomy) {
      this.respondentKnowledge.update({ taxonomyDevice: { ...taxonomy } });
    },

    addQuotasData(quotas) {
      this.respondentKnowledge.update({
        quotas: { ...quotas },
      });
    },

    addQuotaAssignedData(quotaAssigned) {
      this.respondentKnowledge.update({
        quotaAssigned: { ...quotaAssigned },
      });
    },

    addQuotaStrategiesData(quotaStrategies) {
      this.respondentKnowledge.update({
        quotaStrategies: { ...quotaStrategies },
      });
    },

    addQuotaLimitTypesData(quotaLimitTypes) {
      this.respondentKnowledge.update({
        quotaLimitTypes: { ...quotaLimitTypes },
      });
    },

    addNoneOfTheAboveAnswersData(noneOfTheAboveAnswers) {
      this.respondentKnowledge.update({
        noneOfTheAboveAnswers: { ...noneOfTheAboveAnswers },
      });
    },

    addRemainingCompletesData(remainingCompletes) {
      this.respondentKnowledge.update({
        remainingCompletes,
      });
    },

    addAnsweredConcept(nodeId, concept) {
      const storeState = this.respondentKnowledge.store.getState();
      storeState.onAddAnsweredConcept(nodeId, concept);
    },

    addAnsweredChoiceSet(nodeRefId, choiceSetId, blockId) {
      const storeState = this.respondentKnowledge.store.getState();
      storeState.onAddAnsweredChoiceSet(nodeRefId, choiceSetId, blockId);
    },
    getIsPreviousPageGDPR() {
      return this.isPreviousPageGDPR;
    },
    setIsPreviousPageGDPR(isGDPR) {
      this.isPreviousPageGDPR = isGDPR;
    },
    setShuffledAnswers(refId, answers) {
      this.shuffledAnswers[refId] = answers;
    },
    getShuffledAnswers(refId) {
      return this.shuffledAnswers[refId];
    },
  };
})();

export default Pollfish.store;
